var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "message-thinking"
  }, _vm._l(_vm.icons, function (icon, index) {
    return _c('div', {
      key: index
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [icon ? _c('Icon', {
      attrs: {
        "file": _vm.loading_message,
        "width": "14px",
        "height": "14px"
      }
    }) : _vm._e()], 1)], 1);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }